import { useEffect } from 'react';
import { createBrowserHistory } from 'history'; // Import createBrowserHistory from history package
import { useNavigate } from 'react-router';
import logo3 from '../../images/logo3.svg'
import logo4 from '../../images/dancingLogo.gif'
import logo5 from '../../images/KSnAfIccr8Npz735jXAikJoRyMj3P04B2QeHVmIq.webp'
import logo6 from '../../images/fRCIVtMDon9QQtxuOTllvWQamcvkxKNV4Dmal0CM.webp'
import "../../style/Splash.css"

function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/login'); 
    }, 4000);

    return () => {
      clearTimeout(timeout);
    };
  }, []); 

  return (
    <div>
      {/* FUSE Splash Screen */}
      <div id="fuse-splash-screen">
        <div className="logo" >
          <img  src={logo6} alt="logo" />
        </div>
        {/* <div id="spinner">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div> */}
      </div>
      {/* / FUSE Splash Screen */}
    </div>
  );
}

export default SplashScreen;
